import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import {
    child_edit,
    client_info,
    parent_edit,
    postingClients,
    subscription_new,
    to_client_anket,
    to_client_comments,
    to_client_graph,
    to_client_project,
    to_client_subscriptions,
} from '../../../routes';

import { useMutation, useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import CrmLayout from '../../../components/CrmLayout';
import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import { Avatar, Button, Form, Input, Skeleton } from 'antd';
import moment from 'moment';
import cls from './ClientInfo.module.scss';
import ImageUrl from '../../../helpers/ImageUrl';
import { CopyOutlined, EditOutlined, PlusOutlined, RightOutlined, SaveOutlined } from '@ant-design/icons';
import Bonus from '../Bonus/Bonus';
import TelegramOutlined from '../../../vidgets/icon/TelegramOutlined';
import _ from 'lodash';
import ChildParentsSelectAndAdd from '../SelectAndAdd/ChildParentsSelectAndAdd';
import { QUERY_PARENTS, UPDATE_PARENT } from '../../../graphql/parent';
import { phoneMaskToPlain } from '../../../helpers/phone';
import ParentChildrenSelectAndAdd from '../SelectAndAdd/ParentChildrenSelectAndAdd';
import copyToClipboard from '../../../helpers/copyToClipboard';
import { Comment } from '../Comment/Comment';
import { CommentSend } from '../Comment/CommentSend';
import CrmTextModal from '../../../components/Modal/CrmTextModal';
import { Subscription } from '../Subscriptions/Subscription';
import { ModalAvatar } from '../Avatar/ModalAvatar';
import { ModalSelectProject } from '../Project/ModalSelectProject';
import cn from 'classnames';
import { isDark } from '../../../helpers/color';
import { Level } from '../../../components/Project/Level/Level';
import { cleanClientUrl, cleanProjectUrl } from '../../../helpers/url';
import CrmModal from '../../../components/CrmModal';
import { UPDATE_CLIENT } from '../../../graphql/client';

export default function ClientInfo() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [modal, setModal] = React.useState(false);
    const [school, setSchool] = React.useState(false);

    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                limit: 1,
            },
        },
    });
    const [updateClient] = useMutation(UPDATE_CLIENT);
    const [updateParent] = useMutation(UPDATE_PARENT);


    const type = query.data?.usersPermissionsUser?.data?.attributes?.client?.data ? 'child' : 'parent';
    const user = query.data?.usersPermissionsUser?.data?.attributes;
    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;

    const parents = useQuery(QUERY_PARENTS, {
        variables: {
            filters: {
                clients: {
                    id: { eq: client?.id },
                },
            },
        },
        skip: !client || type !== 'child',
    });

    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;
    const telegram = _.find(user?.contacts, (item) => item.type === 'telegram');

    const onEdit = () => {
        navigate(type === 'child' ? child_edit(client?.id) : parent_edit(client?.id));
    };

    const onDelete = () => {
        console.log('onDelete');
    };

    if (!client) {
        return null;
    }

    const url = cleanClientUrl(query.data?.usersPermissionsUser?.data?.attributes?.publicKey);
    const projectUrl = cleanProjectUrl(query.data?.usersPermissionsUser?.data?.attributes?.publicKey);
    const mass = _.reduce(
        client.attributes?.project?.data?.attributes?.experiences,
        (sum, item) => {
            // Проверяем, что list существует и это строка
            if (typeof item.list === 'string' && item.list.trim() !== '') {
                // Разделяем по \n и прибавляем количество получившихся элементов
                return sum + item.list.split('\n').length;
            }
            return sum;
        },
        0,
    );

    const onSchoolLink = async (data) => {
        if (type === 'child') {
            await updateClient({
                variables: {
                    id: client.id,
                    data: {
                        schoolUrl: data.schoolUrl
                    }
                },
                onCompleted: () => {
                    query.refetch()
                    setSchool(false)
                }
            })
        } else {
            await updateParent({
                variables: {
                    id: client.id,
                    data: {
                        schoolUrl: data.schoolUrl
                    }
                },
                onCompleted: () => {
                    query.refetch()
                    setSchool(false)
                }
            })
        }
    }

    return (
        <CrmLayout>
            <CrmCenteredTitle title={title} editAction={onEdit} deleteAction={onDelete} />
            {query.loading && <Skeleton active />}

            <div className={cls.blocks}>
                <div className={cls.block}>
                    <h3>Общие данные</h3>
                    <Avatar
                        size={64}
                        src={ImageUrl(client?.attributes?.avatar?.data?.attributes?.url)}
                        style={{ backgroundColor: client?.attributes?.color }}
                    >
                        {client?.attributes?.firstName.charAt(0)}
                        {client?.attributes?.lastName.charAt(0)}
                    </Avatar>
                    <span>{title}</span>
                    {client?.attributes?.birthDate && (
                        <span>{moment().diff(moment(client.attributes.birthDate), 'years')} лет</span>
                    )}
                    <div className={cls.control}>
                        <Link to={type === 'child' ? child_edit(client?.id) : parent_edit(client?.id)}>
                            <Button type={'link'} icon={<EditOutlined />}>
                                Редактировать
                            </Button>
                        </Link>
                        <ModalAvatar client={client} type={type} onUpdate={() => query.refetch()} />
                    </div>
                </div>

                <div className={cls.columns}>
                    <div className={cls.block}>
                        <h3>
                            <Link to={to_client_anket(id)}>
                                Анкета <Button type={'link'} icon={<RightOutlined />} />
                            </Link>
                        </h3>
                        {client.attributes?.anket ? (
                            <Link to={to_client_anket(id)}>
                                <Button type={'link'} icon={<EditOutlined />}>
                                    Изменить
                                </Button>
                            </Link>
                        ) : (
                            <>
                                <span>Не заполнена</span>
                                <Link to={to_client_anket(id)}>
                                    <Button type={'link'} icon={<EditOutlined />}>
                                        Заполнить
                                    </Button>
                                </Link>
                            </>
                        )}
                    </div>
                    <div className={cls.block}>
                        <h3>Учеба</h3>
                        {client.attributes?.schoolUrl ? (
                            <>
                                <a className={cls.url} href={client.attributes?.schoolUrl} target={'_blank'} rel={'noreferrer'}>{client.attributes?.schoolUrl}</a>
                                <Button type={'link'} icon={<EditOutlined />} onClick={() => setSchool(true)}>
                                    Изменить
                                </Button>
                            </>
                        ) : (
                            <>
                                <span>Нет ссылки</span>
                                <Button type={'link'} icon={<EditOutlined />} onClick={() => setSchool(true)}>
                                    Заполнить
                                </Button>
                            </>
                        )}
                        <CrmTextModal isOpen={school} onClose={() => setSchool(false)} title={'Ссылка на учебу'}>
                            <div className={cls.content}>
                                <Form layout={'vertical'} onFinish={onSchoolLink} initialValues={{schoolUrl: client.attributes?.schoolUrl}}>
                                    <Form.Item label={'Ссылка'} name={'schoolUrl'} rules={[
                                        {type: 'url', message: 'Не похоже на ссылку'}
                                    ]}>
                                        <Input placeholder={'https://...'}/>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type={'primary'} icon={<SaveOutlined />} htmlType={'submit'}>
                                            Сохранить
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </CrmTextModal>
                    </div>
                </div>

                <div className={cls.columns}>
                    <div className={cls.block}>
                        <h3>Сила (Бонус)</h3>
                        <Bonus id={client?.id} value={client?.attributes?.bonus} child={type === 'child'} />
                    </div>

                    <div className={cls.block}>
                        <h3>Телеграм</h3>
                        {telegram ? (
                            <>
                                <span>{telegram.data?.chat?.username || telegram.data?.chat?.id}</span>
                                <div className={cls.control}>
                                    {telegram.data?.chat?.username && (
                                        <a
                                            href={`https://t.me/${telegram.data?.chat?.username}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <Button type={'link'} icon={<RightOutlined />}>
                                                Перейти в чат
                                            </Button>
                                        </a>
                                    )}
                                    <Link to={postingClients([id])}>
                                        <Button type={'link'} icon={<TelegramOutlined />}>
                                            Создать рассылку
                                        </Button>
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <>
                                <span>Не подключен</span>
                                <Button type={'link'} onClick={() => setModal(true)}>
                                    Подключить
                                </Button>
                                <CrmTextModal
                                    isOpen={modal}
                                    onClose={() => setModal(false)}
                                    title={'Подключить телеграм'}
                                >
                                    <div className={cls.content}>
                                        <span>
                                            Для подключения телеграм отправьте пользователю ссылку на его персональную
                                            страницу
                                        </span>
                                        <a href={url} target={'_blank'} rel={'noreferrer'}>
                                            {url}
                                        </a>
                                        <Button
                                            type={'link'}
                                            icon={<CopyOutlined />}
                                            onClick={() => copyToClipboard(url)}
                                        >
                                            Скопировать
                                        </Button>
                                        <span>Попросите:</span>
                                        <span>1) Нажать на кнопку Подключиться</span>
                                        <span>2) Перейти в приложение в чат с ботом</span>
                                        <span>3) Нажать кнопку Start</span>
                                    </div>
                                </CrmTextModal>
                            </>
                        )}
                    </div>
                </div>

                {type === 'child' && (
                    <div className={cls.block}>
                        <h3>Родители</h3>
                        {_.map(parents.data?.parents?.data, (parent) => (
                            <div key={parent.id} className={cls.contact}>
                                <span>
                                    {parent.attributes.firstName} {parent.attributes.lastName}{' '}
                                    <Link to={client_info(parent.attributes?.account?.data?.id)}>
                                        <Button type={'link'} icon={<RightOutlined />} />
                                    </Link>
                                </span>
                                {_.map(parent.attributes?.account?.data?.attributes?.contacts, (contact, index) => (
                                    <div key={index}>
                                        {contact.type === 'phone' && (
                                            <a href={`tel:${phoneMaskToPlain(contact.value)}`}>
                                                <Button type={'link'}>{contact.value}</Button>
                                            </a>
                                        )}
                                        {contact.type === 'email' && (
                                            <a href={`mailto:${contact.value}`}>
                                                <Button type={'link'}>{contact.value}</Button>
                                            </a>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                        <div className={cls.control}>
                            <ChildParentsSelectAndAdd
                                childId={client.id}
                                onUpdate={() => parents.refetch()}
                                parents={parents.data?.parents?.data || []}
                            />
                        </div>
                    </div>
                )}

                {type === 'parent' && (
                    <div className={cls.block}>
                        <h3>Дети</h3>
                        {_.map(client?.attributes?.clients?.data, (child) => (
                            <div key={child.id} className={cls.contact}>
                                <span>
                                    {child.attributes.firstName} {child.attributes.lastName}{' '}
                                    <Link to={client_info(child.attributes?.account?.data?.id)}>
                                        <Button type={'link'} icon={<RightOutlined />} />
                                    </Link>
                                </span>
                            </div>
                        ))}
                        <div className={cls.control}>
                            <ParentChildrenSelectAndAdd
                                childId={client.id}
                                onUpdate={() => parents.refetch()}
                                children={client?.attributes?.clients?.data || []}
                            />
                        </div>
                    </div>
                )}

                {client.attributes?.project?.data ? (
                    <div className={cls.grid}>
                        <div
                            className={cn(
                                cls.block,
                                cls.project,
                                isDark(client.attributes?.project?.data?.attributes?.color || '#F0F0F0') && cls.white,
                            )}
                            style={{
                                backgroundColor: client.attributes?.project?.data?.attributes?.color,
                                backgroundImage: `url(${ImageUrl(
                                    client.attributes?.project?.data?.attributes?.cover?.data?.attributes?.url,
                                )})`,
                            }}
                        >
                            <h3>
                                <Link to={to_client_project(id)}>
                                    {client.attributes?.project?.data?.attributes?.name}{' '}
                                    <Button type={'link'} icon={<RightOutlined />} />
                                </Link>
                            </h3>
                            {client.attributes?.project?.data?.attributes?.logo?.data && (
                                <img
                                    className={cls.logo}
                                    src={ImageUrl(
                                        client.attributes?.project?.data?.attributes?.logo?.data?.attributes?.url,
                                    )}
                                    alt={'logo'}
                                />
                            )}
                            <ModalSelectProject
                                current={client.attributes?.project?.data?.id}
                                client={client}
                                type={type}
                                onUpdate={() => query.refetch()}
                                edit
                            />
                        </div>
                        <div className={cls.block}>
                            <Level
                                color={client.attributes?.project?.data?.attributes?.color}
                                value={client.attributes?.projectData?.length || 0}
                                mass={mass}
                                levels={client.attributes?.project?.data?.attributes?.levels}
                                min
                            />
                            <Link to={to_client_project(id)}>
                                <Button type={'link'} icon={<EditOutlined />}>
                                    Внести данные
                                </Button>
                            </Link>
                        </div>
                        <div className={cls.block}>
                            <h3>
                                <a href={projectUrl} target={'_blank'} rel={'noreferrer'}>
                                    Страница проекта <Button type={'link'} icon={<RightOutlined />} />
                                </a>
                            </h3>
                            <div className={cls.url}>{projectUrl}</div>
                            <Button type={'link'} icon={<CopyOutlined />} onClick={() => copyToClipboard(projectUrl)}>
                                Скопировать
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className={cls.block}>
                        <h3>Проект</h3>
                        <span>Не добавлен</span>
                        <ModalSelectProject client={client} type={type} onUpdate={() => query.refetch()} />
                    </div>
                )}

                <div className={cls.block}>
                    <h3>
                        <Link to={to_client_comments(id)}>
                            Комментарии <Button type={'link'} icon={<RightOutlined />} />
                        </Link>
                    </h3>
                    {client.attributes?.messages?.data?.length > 0 && (
                        <Comment
                            createdAt={client.attributes?.messages?.data[0].attributes.createdAt}
                            firstName={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.firstName
                            }
                            lastName={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.lastName
                            }
                            url={
                                client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.avatar?.data
                                    ?.attributes?.url
                            }
                            color={client.attributes?.messages?.data[0].attributes.author?.data?.attributes?.color}
                            message={client.attributes?.messages?.data[0].attributes.message}
                        />
                    )}
                    <CommentSend id={client.id} onUpdate={() => query.refetch()} child={type === 'child'} />
                </div>

                <div className={cls.block}>
                    <h3>
                        <Link to={to_client_subscriptions(id)}>
                            Абонементы <Button type={'link'} icon={<RightOutlined />} />
                        </Link>
                    </h3>
                    <Subscription id={id} />
                    <Link to={subscription_new(id)}>
                        <Button type={'link'} icon={<PlusOutlined />}>
                            Создать
                        </Button>
                    </Link>
                </div>

                {/*<div className={cls.columns}>*/}
                {/*<div className={cls.block}>*/}
                {/*    <h3>*/}
                {/*        <Link to={to_client_graph(id)}>*/}
                {/*            Цели, навыки, графики <Button type={'link'} icon={<RightOutlined />} />*/}
                {/*        </Link>*/}
                {/*    </h3>*/}
                {/*</div>*/}
                {/*</div>*/}

                {/*<div className={cls.block}>*/}
                {/*    <h3>*/}
                {/*        <a href={url} target={'_blank'} rel={'noreferrer'}>*/}
                {/*            Страница <Button type={'link'} icon={<RightOutlined />} />*/}
                {/*        </a>*/}
                {/*    </h3>*/}
                {/*    <div className={cls.url}>{url}</div>*/}
                {/*    <Button type={'link'} icon={<CopyOutlined />} onClick={() => copyToClipboard(url)}>*/}
                {/*        Скопировать*/}
                {/*    </Button>*/}
                {/*</div>*/}
            </div>
        </CrmLayout>
    );
}
